import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { HbmIframeService } from '../../services/hbm/hbm-iframe.service';
import { CustomerService } from 'src/app/services/customer.service';
import { CurrentService } from 'src/app/services/current.service';
import { TunnelService } from 'src/app/services/tunnel.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ng-casto-configuration',
  templateUrl: './configuration.component.html',
})
export class ConfigurationComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('byMeIframe', { static: false }) iframeRef!: ElementRef<HTMLIFrameElement>;
  private origin!: string;

  constructor(
    private readonly byMe: HbmIframeService,
    private readonly router: Router,
    public readonly customer: CustomerService,
    public current: CurrentService,
    public tunnelService: TunnelService
  ) { }

  ngOnInit(): void {
    this.byMe.setComponentState(true);

    const _route = this.router.url.split('/')[1];
    switch (_route) {
      case 'rangements': this.customer.context = CONFIG_CONTEXT.STORAGE; break;
      case 'cuisine': this.customer.context = CONFIG_CONTEXT.KITCHEN; break;
      case 'salle-de-bain': this.customer.context = CONFIG_CONTEXT.BATHROOM; break;
    }

    this.origin = environment.byMe[this.customer.context].origin;
  }

  ngAfterViewInit(): void {
    const iframe = this.iframeRef.nativeElement;
    iframe.src = this.byMe.buildInitialUrl();
    this.byMe.attachIframe(iframe);
  }

  ngOnDestroy(): void {
    this.byMe.detachIframe();
    this.byMe.setComponentState(false);
  }

  @HostListener('window:message', ['$event'])
  onWindowMessage(ev: MessageEvent) {
    if (!ev?.origin || ev.origin !== this.origin) return;
    if (!ev.data) return;
    this.byMe.handleIframeMessage(ev);
  }
}
